import React from 'react';
import { Button, Collapse } from 'react-bootstrap';

const RODOstartText = <div><p style={{ textAlign: 'center' }}><br></br><b>Klauzula informacyjna o przetwarzaniu danych.</b></p>
    <p style={{ textAlign: 'justify' }}>Zgodnie z art. 13 ust. 1 i ust. 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE)
         2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w
         sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) z
     dnia 27 kwietnia 2016 r. (Dz.Urz.UE.L Nr 119, str. 1)<br></br><br></br>zwanym dalej RODO informuję, iż:</p></div>

const RODOconfirmText = <div>
    <ol style={{ textAlign: 'justify' }}>
        <li>Administratorem Pani/Pana danych osobowych jest Burmistrz Białej Rawskiej</li>
        <li>Kontakt z inspektorem ochrony danych: magdalena@kuszmider.com.pl</li>
        <li>Pani/Pana dane osobowe przetwarzane będą w celu realizacji rozpatrzenia
            wniosku o wydanie wypisu i wyrysu z Miejscowego Planu Zagospodarowania Przestrzennego</li>
        <li>Podstawą przetwarzania danych osobowych są obowiązujące przepisy prawa tj. ustawa z dnia 14
            czerwca 1960 r. Kodeks Postępowania Administracyjnego, ustawa z dnia 27 marca 2003 r. o
            planowaniu  i zagospodarowaniu przestrzennym.</li>
        <li>Dane osobowe nie będą udostępniane innym odbiorcom, niż uprawnione na mocy przepisów prawa.</li>
        <li>Pani/Pana dane osobowe nie będą przekazywane do państwa trzeciego, organizacji międzynarodowej.</li>
        <li>Pani/Pana dane osobowe będą przechowywane przez okres wynikający z przepisów prawa oraz zgodnie z
            rozporządzeniem Prezesa Rady Ministrów z dnia 18 stycznia 2011 r. w sprawie instrukcji kancelaryjnej,
            jednolitych rzeczowych wykazów akt oraz instrukcji w sprawie organizacji i zakresu działania archiwów
            zakładowych (Dz. U. Nr 14, poz. 67 ze zm.).</li>
        <li>Posiada Pani/Pan prawo dostępu do treści swoich danych oraz prawo ich sprostowania.</li>
        <li>Przetwarzanie odbywa się na podstawie art. 6 pkt.1.c RODO.</li>
        <li>Ma Pani/Pan prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych gdy uzna
            Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy ogólnego
            rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r.</li>
        <li>Podanie przez Panią/Pana danych osobowych jest wymogiem ustawowym. Jest Pan/Pani zobowiązana
            do ich podania, konsekwencją ich niepodania będzie brak możliwości rozpatrzenia wniosku.</li>
        <li>Pani/Pana dane nie będą przetwarzane w sposób zautomatyzowany, w tym również w formie profilowania.</li>
    </ol>
    <p style={{ textAlign: 'justify' }}>Podając numer telefonu wyraża Pan/Pani zgodę na jego przetwarzanie celem
    zapewnienia szybkiej i sprawnej komunikacji związanej z realizacją złożonego wniosku.
    Wiem, że złożenie tej zgody jest dobrowolne i mam prawo jej wycofania w każdym momencie, a
    numer telefonu nie będzie udostępniany innym odbiorcom.</p>
</div>;

const btnStyle = {
    borderRadius: 0,
    border: 'none',
    padding: '5px 5px',
    marginLeft: '5px',
    background: 'white'
};

const insertKeyAtPosition = (dict, key, value, position) => {
    const entries = Object.entries(dict);
    entries.splice(position, 0, [key, value]);
    const newDict = Object.fromEntries(entries);

    return newDict;
};

const deleteKeys = (dict, keys) => {
    for (const key of keys) {
        if (dict.hasOwnProperty(key)) {
            delete dict[key];
        }
    }
    return dict;
  }

class RODOBialaRawska extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            buttonText: 'Więcej'
        };
    }

    collapseText = () => {
        if (this.state.buttonText == 'Więcej') {
            this.setState({ buttonText: 'Mniej' })
        }
        else {
            this.setState({ buttonText: 'Więcej' })
        }
        this.setState({ open: !this.state.open })
    };

    render() {
        return (
            <div class="container">
                {RODOstartText}
                <Collapse in={this.state.open}>
                    <div>
                        {RODOconfirmText}
                    </div>
                </Collapse>
                <Button
                    style={{ float: 'right', ...btnStyle }}
                    onClick={() => this.collapseText()}
                >
                    {this.state.buttonText == 'Więcej' ?
                        <div><span className="glyphicon glyphicon-menu-down" />
                            <text style={{ margin: '0 5px 0 5px' }}>
                                {this.state.buttonText}
                            </text></div> :
                        <div><span className="glyphicon glyphicon-menu-up" />
                            <text style={{ margin: '0 5px 0 5px' }}>
                                {this.state.buttonText}
                            </text></div>}
                </Button>


            </div>
        )
    }
}

export default {
    RODOBialaRawska,
    insertKeyAtPosition,
    deleteKeys
};


// WEBPACK FOOTER //
// src/routes/eservices/utils.js